<template>
  <Dialogs :dialog="dialog" :handleClose="close">
    <template #content>
      <div class="dialog_content">
        <el-form ref="form" :model="form" :rules="rules" :label-width="form.type=='10'?'140px':'100px'" size="small">
          <el-form-item label="发布类型" prop="type">
            <el-select :disabled="data.title == '详情'" v-model="form.type" placeholder="请选择">
              <el-option label="政策信息发布" :value="0"> </el-option>
              <!-- <el-option label="政策信息" :value="0"> </el-option> -->
              <!-- <el-option label="工作推进成果" :value="1"> </el-option> -->
              <el-option label="日常动态" :value="1"> </el-option>
              <el-option label="碳中和" :value="2"> </el-option>
              <el-option label="研究成果" :value="3"> </el-option>
              <el-option label="零碳园区" :value="4"> </el-option>
              <el-option label="零碳景区" :value="5"> </el-option>
              <el-option label="零碳农产品" :value="6"> </el-option>
              <el-option label="零碳+教育普及" :value="7"> </el-option>
              <el-option label="首页" :value="8"> </el-option>
              <el-option label="宁碳惠项目" :value="9"> </el-option>
              <el-option label="认购公示" :value="10"> </el-option>
              <el-option label="碳汇+N" :value="11"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item id="time" v-if="form.type!='11'&&form.type!='10'" label="发布日期" prop="startDate" class="inlinitem">
            <el-date-picker :disabled="data.title == '详情'" v-model="form.startDate" type="date" format="yyyy-MM-dd"
              value-format="yyyy-MM-dd" style="width: 200px" placeholder="开始日期" :picker-options="pickerOptions3">
            </el-date-picker>
          </el-form-item>
          <el-form-item id="time" v-if="form.type=='10'" label="申请时间" prop="startDate" class="inlinitem">
            <el-date-picker :disabled="data.title == '详情'" v-model="form.startDate" type="date" format="yyyy-MM-dd"
              value-format="yyyy-MM-dd" style="width: 200px" placeholder="开始日期" :picker-options="pickerOptions3">
            </el-date-picker>
          </el-form-item>
          <el-form-item class="inlinitem" v-if="form.type!='11'" prop="endDate">
            <el-date-picker :disabled="data.title == '详情'" v-model="form.endDate" type="date" format="yyyy-MM-dd"
              value-format="yyyy-MM-dd" style="width: 200px" :picker-options="pickerOptions4" placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="form.type=='10'?'企业名称':form.type=='11'?'林场名称':'政策主题'" prop="policyTheme">
            <el-input style="width:405px;" maxlength="100" :disabled="data.title == '详情'" v-model="form.policyTheme"
              placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item v-if="form.type=='10'||form.type=='11'" :label="form.type=='10'?'申请具体减排量':'碳票数量(kg)'" prop="carbonTicketsQuantity">
            <el-input style="width:405px;" maxlength="100" :disabled="data.title == '详情'" v-model="form.carbonTicketsQuantity"
              placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item v-if="form.type=='10'"  label="成交均价(元/每吨)" prop="dealAveragePrice">
            <el-input style="width:405px;" maxlength="100" :disabled="data.title == '详情'" v-model="form.dealAveragePrice"
              placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item :label="form.type=='10'?'申请书上传':form.type=='11'?'认购模板':'附件'" class="uploader">
            <el-upload class="avatar-uploader" action="" :before-upload="beforeAvatarUpload" :file-list="fileList"
              :http-request="customUpload1" :on-remove="deleteFile" :disabled="data.title == '详情'">
              <el-button class="upCss" size="small" :disabled="data.title == '详情'">上传文件</el-button>
              <div slot="tip" class="el-upload__tip">
                <span>仅支持.doc,.docx,.xls,.pdf .png,.jpg,.svg,.mov,.mp4的文件上传</span>
                <!-- <span v-if="form.type=='1'">仅支持.png,.jpg,.svg,.mov,.mp4视频的上传</span> -->
                <!-- <span v-else-if="form.type=='0'">支持doc,.docx,.xls,.pdf,.png,.jpg,.svg等格式的文件，且不超过500MB</span>
                  <span v-else-if="form.type=='2'||form.type=='3'">支持.png,.jpg,.svg等格式的文件，且不超过500MB</span> -->
              </div>
            </el-upload>
          </el-form-item>
          <el-form-item :label="form.type=='10'?'企业介绍':form.type=='11'?'林场介绍':'政策内容'" style="height: 100%" :prop="form.type == '0' ? 'policyContent' : ''">
            <!-- <el-input
                type="textarea"
                class="h120"
                v-model="form.policyContent"
              ></el-input> -->
            <el-upload style="display: none;" class="quill-uploader" action="" :before-upload="beforeAvatarUploadTwo"
              :http-request="customUpload2">
              <el-button class="upCss" size="small">上传文件</el-button>
              <div slot="tip" class="el-upload__tip">
                <span>仅支持.doc,.docx,.xls,.pdf .png,.jpg,.svg,.mov,.mp4的文件上传</span>
                <!-- <span v-if="form.type=='1'">仅支持.png,.jpg,.svg,.mov,.mp4视频的上传</span> -->
                <!-- <span v-else-if="form.type=='0'">支持doc,.docx,.xls,.pdf,.png,.jpg,.svg等格式的文件，且不超过500MB</span>
                  <span v-else-if="form.type=='2'||form.type=='3'">支持.png,.jpg,.svg等格式的文件，且不超过500MB</span> -->
              </div>
            </el-upload>


            <quill-editor v-maxWindow :disabled="data.title == '详情'" v-model="form.policyContent" ref="quillEditor"
              :options="editorOption" @blur="onEditorBlur($event)" @focus="onEditorFocus($event)"
              @change="onEditorChange($event)" @ready="onEditorReady($event)">
            </quill-editor>
          </el-form-item>
        </el-form>

        <!-- <div class="detail" v-else>
          <div class="detail_theme">
            {{ form.policyTheme }}
          </div>
          <div class="detail_issueDate">
            发布时间：{{ form.startDate }} 至 {{ form.endDate }}
          </div>
          <pre class="detail_content">{{ form.policyContent }}</pre>
          <div class="detail_file">
            <div class="detail-file-item" v-for="item in fileList" :key="item.id">
              <img
                v-if="item.type == 'jpg' || item.type == 'png' || item.type == 'jpeg' | item.type == 'svg' || item.type == 'webp' || item.type == 'jfif'"
                :src="item.url" alt="">
              <video controls v-if="item.type == 'mp4' || item.type == 'mov'" :src="item.url"></video>
              <a :href="item.url"
                v-if="item.type == 'pdf' || item.type == 'docx' || item.type == 'doc' || item.type == 'xls' || item.type == 'xlsx' || item.type == 'ppt' || item.type == 'pptx'">{{
                  item.name }}</a>
            </div>
          </div>
        </div> -->

      </div>
    </template>
    <!-- 按钮 -->
    <template #btns v-if="showBtn">
      <el-button @click="close">取消</el-button>
      <el-button type="primary" @click="submitForm">提交</el-button>
    </template>
  </Dialogs>
</template>
<script>
import { policyInfoSubmit, removeFileById, fileUpload } from "@/api/api"
import Dialogs from "@/components/dialogs/dialogs.vue"
import { quillEditor } from 'vue-quill-editor'
import Quill from 'quill'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import imageResize from 'quill-image-resize-module'
import screen from '../../../../utils/Screen' //自定义v-screen 指令
Quill.register('modules/imageResize', imageResize)

// 字体设置
const fontSizeStyle = Quill.import('attributors/style/size') // 引入这个后会把样式写在style上
fontSizeStyle.whitelist = ['12px', '14px', '16px', '18px', '20px', '24px', '28px', '36px', '48px', '72px']
Quill.register(fontSizeStyle, true)
// 设置字体样式
const Font = Quill.import('attributors/style/font') // 引入这个后会把样式写在style上
const fonts = ['SimSun', 'SimHei', 'Microsoft-YaHei', 'KaiTi', 'FangSong']
Font.whitelist = fonts // 将字体加入到白名单
Quill.register(Font, true)

export default {
  props: ['dialog', 'handleClose', 'isView', 'formData'],

  directives: { screen },
  data() {
    return {
      data: {
        size: 720,
        visible: true,
        title: "新增",
      },
      loading: false,
      close: function () { },
      showBtn: false,
      // 提交表单
      form: {
        policyTheme: "", // 政策主题
        startDate: "",
        endDate: "",
        policyContent: "", // 政策内容
        type: "", // 政策类型（0：政策学习，1：宣传报道）
        accessory: '' // 附件
      },
      // 文件列表
      fileList: [],
      // 校验
      rules: {
        type: [{ required: true, message: "请选择政策类型" }],
        startDate: [{ required: true, message: "选择开始日期" }],
        endDate: [{ required: true, message: "选择结束日期" }],
        policyTheme: [{ required: true, message: "填写政策主题" }],
        policyContent: [{ required: true, message: "填写活动形式" }],
      },
      files: [],
      editorOption: {
        placeholder: '',
        theme: 'snow', // or 'bubble'
        placeholder: '请输入内容',
        modules: {
          toolbar: {
            container: [
              ['bold', 'italic', 'underline', 'strike'],        // 加粗，斜体，下划线，删除线
              ['blockquote', 'code-block'],                      //引用，代码块

              [{ 'list': 'ordered' }, { 'list': 'bullet' }],     // 有序列表，无序列表
              [{ 'script': 'sub' }, { 'script': 'super' }],      // 下角标，上角标
              [{ 'indent': '-1' }, { 'indent': '+1' }],          // 缩进
              [{ 'direction': 'rtl' }],                         // 文字输入方向
              [{ 'align': [] }], // 居中

              ['image', 'video'],  // 上传图片、上传视频
              [{ 'size': ['small', false, 'large', 'huge'] }],  // 字体大小
              // [{ 'size': ['small', 'large', 'huge'] }],  // 字体大小
              [{ 'header': [1, 2, 3, 4, 5, 6, false] }],// 标题
              [{ 'color': [] }, { 'background': [] }],          // 颜色选择
              [{ 'font': ['SimSun', 'SimHei', 'Microsoft-YaHei', 'KaiTi', 'FangSong', 'Arial'] }],// 字体
              ['clean'],                                       // 清除样式,


            ],
            handlers: {
              lineheight: (value) => {
                if (value) {
                  let quill = this.$refs.quillEditor.quill
                  quill.format('lineHeight', value)
                }
              },
              // 调用image上传事件（注意）
              image: (value) => {
                if (value) {
                  document.querySelector('.quill-uploader input').click()
                } else {
                  this.quill.format('image', false)
                }
              },
              video: (value) => {
                if (value) {
                  document.querySelector('.quill-uploader input').click()
                } else {
                  this.quill.format('video', false);
                }
              },
            },
          },
          history: {
            delay: 1000,
            maxStack: 50,
            userOnly: false,
          },
          // ImageDrop:true,//拖动图片
          imageResize: {
            displayStytles: {
              backgroundColor: 'black',
              border: 'none',
              color: 'white'
            }
          }
        },

      },
      fileId: [],
      pickerOptions3: {
        disabledDate: (time) => {
          const start = Date.parse(this.form.startDate);
          const end = Date.parse(this.form.endDate);
          if (this.form.endDate) {
            return time.getTime() > Date.now() || time.getTime() > end;
          } else {
            return time.getTime() > Date.now();
          }
        },
      },
      pickerOptions4: {
        disabledDate: (time) => {
          const start = Date.parse(this.form.startDate);
          const end = Date.parse(this.form.endDate);
          if (this.form.startDate) {
            return (
              time.getTime() < start - 1000 * 60 * 60 * 24
            );
          } else {
            // return time.getTime() > Date.now();
          }
        },
      },
    }
  },
  methods: {

    initEdit() {
      // toolbar标题
      const titleConfig = [
        { Choice: '.ql-insertMetric', title: '跳转配置' },
        { Choice: '.ql-bold', title: '加粗' },
        { Choice: '.ql-italic', title: '斜体' },
        { Choice: '.ql-underline', title: '下划线' },
        { Choice: '.ql-header', title: '段落格式' },
        { Choice: '.ql-strike', title: '删除线' },
        { Choice: '.ql-blockquote', title: '块引用' },
        { Choice: '.ql-code', title: '插入代码' },
        { Choice: '.ql-code-block', title: '插入代码段' },
        { Choice: '.ql-font', title: '字体' },
        { Choice: '.ql-size', title: '字体大小' },
        { Choice: '.ql-list[value="ordered"]', title: '编号列表' },
        { Choice: '.ql-list[value="bullet"]', title: '项目列表' },
        { Choice: '.ql-direction', title: '文本方向' },
        { Choice: '.ql-header[value="1"]', title: 'h1' },
        { Choice: '.ql-header[value="2"]', title: 'h2' },
        { Choice: '.ql-align', title: '对齐方式' },
        { Choice: '.ql-color', title: '字体颜色' },
        { Choice: '.ql-background', title: '背景颜色' },
        { Choice: '.ql-image', title: '图像' },
        { Choice: '.ql-video', title: '视频' },
        { Choice: '.ql-link', title: '添加链接' },
        { Choice: '.ql-formula', title: '插入公式' },
        { Choice: '.ql-clean', title: '清除字体格式' },
        { Choice: '.ql-script[value="sub"]', title: '下标' },
        { Choice: '.ql-script[value="super"]', title: '上标' },
        { Choice: '.ql-indent[value="-1"]', title: '向左缩进' },
        { Choice: '.ql-indent[value="+1"]', title: '向右缩进' },
        { Choice: '.ql-header .ql-picker-label', title: '标题大小' },
        { Choice: '.ql-header .ql-picker-item[data-value="1"]', title: '标题一' },
        { Choice: '.ql-header .ql-picker-item[data-value="2"]', title: '标题二' },
        { Choice: '.ql-header .ql-picker-item[data-value="3"]', title: '标题三' },
        { Choice: '.ql-header .ql-picker-item[data-value="4"]', title: '标题四' },
        { Choice: '.ql-header .ql-picker-item[data-value="5"]', title: '标题五' },
        { Choice: '.ql-header .ql-picker-item[data-value="6"]', title: '标题六' },
        { Choice: '.ql-header .ql-picker-item:last-child', title: '标准' },
        { Choice: '.ql-size .ql-picker-item[data-value="small"]', title: '小号' },
        { Choice: '.ql-size .ql-picker-item[data-value="large"]', title: '大号' },
        { Choice: '.ql-size .ql-picker-item[data-value="huge"]', title: '超大号' },
        { Choice: '.ql-size .ql-picker-item:nth-child(2)', title: '标准' },
        { Choice: '.ql-align .ql-picker-item:first-child', title: '居左对齐' },
        { Choice: '.ql-align .ql-picker-item[data-value="center"]', title: '居中对齐' },
        { Choice: '.ql-align .ql-picker-item[data-value="right"]', title: '居右对齐' },
        { Choice: '.ql-align .ql-picker-item[data-value="justify"]', title: '两端对齐' }
      ]
      for (let item of titleConfig) {
        let tip = document.querySelector('.quill-editor ' + item.Choice)
        if (!tip) continue
        tip.setAttribute('title', item.title)
      }
    },

    // 提交
    async submitForm() {
      let bol = true;
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          bol = false;
          return false;
        }
      });
      if (bol) {
        // if (this.fileId.length) {
        //   for (let i = 0; i < this.fileId.length; i++) {
        //     await this.deleteidFile(this.fileId[i]);
        //   }
        // }
        if (this.files.length) {
          for (let i = 0; i < this.files.length; i++) {
            await this.upload(this.files[i]);
          }
        }
        if (this.form.accessory || this.fileId.length)
          this.form.accessory = JSON.stringify(this.fileList)

        // 解决文本带p标签问题,但会去掉图片
        // const reg = /<\/?.+?\/?>/g
        // this.form.policyContent = this.form.policyContent.replace(reg, '')
        const res = await policyInfoSubmit(this.form)
        if (res.data.code == 200) {
          this.data.visible = false
          this.$parent.getList()
          this.$message.success(res.data.message);
          this.fileId = []
          this.fileList = []
          this.files = []
          console.log(this.form.accessory)
          if (this.form.accessory == "[]") {
            console.log(555)
            this.form.accessory = ""
          }
          console.log(this.form.accessory)
        } else this.$message.error(res.data.message);
      }
    },
    // 上传文件之前的钩子
    beforeAvatarUpload(file) {
      console.log(111)
      let isJPG
      isJPG =
        file.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document" || // docx
        file.type === "application/pdf" || // pdf
        file.type === "application/vnd.ms-excel" || //
        file.type === "image/pdf" || // pdf
        file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || // xlsx
        file.type === "application/msword" || // doc
        file.type === "xls" ||
        file.type === "application/vnd.ms-powerpoint" || // ppt
        file.type === 'application/vnd.openxmlformats-officedocument.presentationml.presentation' || // pptx
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "video/mp4" ||
        file.type === "video/quicktime" ||
        file.type === "image/svg+xml" || // svg
        file.type == "image/webp"
      const isLt2M = file.size / 1024 / 1024 < 200;
      if (!isJPG) {
        this.$message.error(
          "仅支持.doc,.docx,.xls,.pdf .png,.jpg,.svg,.mov,.mp4等格式的文件"
        );
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 200MB!");
      }
      return isJPG && isLt2M;
    },
    //自定义上传
    customUpload1(file) {
      this.files.push(file.file);
    },
    //移除文件的钩子
    deleteFile(file) {
      this.fileList = this.fileList.filter((item) => item.id !== file.id);
      this.fileId.push(file.id);
    },
    // 删除文件id
    async deleteidFile(id) {
      const res = await removeFileById(id);
      if (res.data.code == 200) {
        // this.$message(res.data.message);
        this.$parent.getList()
      } else {
        // this.$message(res.data.message);
      }
    },

    // 失去焦点事件
    onEditorBlur(quill) {
      console.log('editor blur!', quill)
    },
    // 获得焦点事件
    onEditorFocus(quill) {
      console.log('editor focus!', quill)
    },
    // 准备富文本编辑器
    onEditorReady(quill) {
      console.log('editor ready!', quill)
    },
    // 内容改变事件
    onEditorChange({ quill, html, text }) {
      console.log('editor change!', quill, html, text)
      this.policyContent = html
    },

    //自定义上传
    async customUpload2(file) {
      await this.upload1(file.file);
    },

    // //开始上传的函数
    async upload(file) {
      const searchParam = JSON.stringify({
        creatorCode: JSON.parse(localStorage.getItem("userInfo")).id,
        creatorName: JSON.parse(localStorage.getItem("userInfo")).name,
        filename: "",
      });
      const loading = this.$loading({
        lock: true,
        text: "正在上传文件...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      const formData = new FormData();
      formData.append("file", file);
      formData.append("searchParam", searchParam);
      const res = await fileUpload(formData);

      if (res.data.code == 200) {
        loading.close();
        this.fileList.push({
          url: res.data.data[0].fileVisitPath,
          id: res.data.data[0].id,
          name: res.data.data[0].fileOldName,
          type: res.data.data[0].fileType,
        });
        this.form.accessory = [{
          url: res.data.data[0].fileVisitPath,
          id: res.data.data[0].id,
          name: res.data.data[0].fileOldName,
          type: res.data.data[0].fileType,
        }]
      } else loading.close();
    },

    //开始上传的函数
    async upload1(file) {
      // 如果传的是图片
      if (file.type == 'image/png' || file.type == 'image/jpeg' || file.type == 'image/svg+xml' || file.type == 'image/webp') {
        const searchParam = JSON.stringify({
          creatorCode: JSON.parse(localStorage.getItem("userInfo")).id,
          creatorName: JSON.parse(localStorage.getItem("userInfo")).name,
          filename: "",
        });
        const loading = this.$loading({
          lock: true,
          text: "正在上传文件...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        const formData = new FormData();
        formData.append("file", file);
        formData.append("searchParam", searchParam);
        const res = await fileUpload(formData);

        if (res.data.code == 200) {
          loading.close();
          let quill = this.$refs.quillEditor.quill
          let length = quill.getSelection().index
          quill.insertEmbed(length, 'image', res.data.data[0].fileVisitPath)
          // 调整光标到最后
          quill.setSelection(length + 1)
          // this.fileList.push({
          //   url: res.data.data[0].fileVisitPath,
          //   id: res.data.data[0].id,
          //   name: res.data.data[0].fileOldName,
          //   type: res.data.data[0].fileType,
          // });
          // this.form.accessory = [{
          //   url: res.data.data[0].fileVisitPath,
          //   id: res.data.data[0].id,
          //   name: res.data.data[0].fileOldName,
          //   type: res.data.data[0].fileType,
          // }]
        } else loading.close();
        // 如果传的是视频
      } else if (file.type == 'video/mp4' || file.type == 'video/quicktime') {
        const searchParam = JSON.stringify({
          creatorCode: JSON.parse(localStorage.getItem("userInfo")).id,
          creatorName: JSON.parse(localStorage.getItem("userInfo")).name,
          filename: "",
        });
        const loading = this.$loading({
          lock: true,
          text: "正在上传文件...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        const formData = new FormData();
        formData.append("file", file);
        formData.append("searchParam", searchParam);
        const res = await fileUpload(formData);

        if (res.data.code == 200) {
          loading.close();
          let quill = this.$refs.quillEditor.quill
          let length = quill.getSelection().index
          quill.insertEmbed(length, 'video', res.data.data[0].fileVisitPath)
          // 调整光标到最后
          quill.setSelection(length + 1)
          // this.fileList.push({
          //   url: res.data.data[0].fileVisitPath,
          //   id: res.data.data[0].id,
          //   name: res.data.data[0].fileOldName,
          //   type: res.data.data[0].fileType,
          // });
          // this.form.accessory = [{
          //   url: res.data.data[0].fileVisitPath,
          //   id: res.data.data[0].id,
          //   name: res.data.data[0].fileOldName,
          //   type: res.data.data[0].fileType,
          // }]
        } else loading.close();
      }

    },

    //调整视频大小 目前无效
    // adjustVideoSize(event, video) {
    //   console.log(event)
    //   console.log(video)
    //   const startWidth = video.width;
    //   const startHeight = video.height;
    //   const startX = event.clientX;
    //   const startY = event.clientY;

    //   const mouseMoveHandler = (e) => {
    //     const width = startWidth + (e.clientX - startX);
    //     const height = startHeight + (e.clientY - startY);
    //     video.style.width = `${width}px`;
    //     video.style.height = `${height}px`;
    //   };

    //   const mouseUpHandler = () => {
    //     document.removeEventListener('mousemove', mouseMoveHandler);
    //     document.removeEventListener('mouseup', mouseUpHandler);
    //   };

    //   document.addEventListener('mousemove', mouseMoveHandler);
    //   document.addEventListener('mouseup', mouseUpHandler);
    // }

  },
  components: {
    Dialogs,
    quillEditor
  },

  watch: {
    dialog: {
      handler(val) {
        this.$set(this, 'data', val)
      },
      immediate: true
    },
    handleClose: {
      handler(val) {
        this.$set(this, 'close', val)
      },
      immediate: true
    },
    isView: {
      handler(val) {
        this.$set(this, 'showBtn', val)
      },
      immediate: true
    },
    formData: {
      handler(val) {
        this.fileList = []
        if (val.accessory) {
          val.accessory = JSON.parse(val.accessory)
          this.fileList = val.accessory
        }
        this.$set(this, 'form', val)
        this.$nextTick(() => {
          if (this.$refs.form)
            this.$refs.form.clearValidate();
        })
      },
    },
  },
  // mounted() {
  // const quill = this.$refs.quillEditor.quill;
  // console.log(quill)
  // // 监听 video 元素的插入，添加拖拽功能
  // quill.root.addEventListener('click', (event) => {
  //   console.log(123)
  //   console.log(event)
  //   const target = event.target;
  //   if (target.tagName === 'video') {
  //     target.addEventListener('mousedown', (e) => this.adjustVideoSize(e, target));
  //   }
  // });
  // },

}
</script>
<style scoped>
@import "../css/quill-editor.css";

::v-deep .inlinitem.el-form-item {
  display: inline-flex;
  justify-content: flex-start;
}

::v-deep .inlinitem.el-form-item .el-form-item__content {
  margin-left: 2px !important;
}

.h120 {
  height: 120px;
}

::v-deep .h120 .el-textarea__inner {
  height: 120px;
}

.detail_theme {
  margin: 16px 0;
  font-size: 24px;
  text-align: center;
  color: #333;
}

.detail_issueDate {
  margin-bottom: 20px;
  font-size: 18px;
  color: #333;
}

.detail_content {
  margin-bottom: 20px;
  font-size: 16px;
  white-space: pre-wrap;
  word-wrap: break-word;
  font-family: '微软雅黑';
  color: #333;
}

.detail_file a {
  color: #409EFF;
  text-decoration: none;
}

.detail_file img,
.detail_file video {
  width: 100%;
  display: block;
}

.detail-file-item {
  margin-bottom: 20px;
}

::v-deep .ql-editor {
  border-color: #ccc;
  /* height: 125px !important; */
  height: 125px;
  overflow: auto;
}

/* .ql-editor video {
  max-width: 100%;
  height: auto;
  display: block;
  margin: 0 auto;
  cursor: pointer;
}

.ql-editor video:active {
  cursor: grabbing;
} */
</style>
